export enum REPORT_ISSUE_TYPE {
  GENERAL_FEEDBACK = 'General feedback',
  INCORRECT_DATA = 'Incorrect data',
  BUG_OR_FEATURE = 'Bug or feature request',
}
